<template>
  <div>
    <svg width="800" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <rect v-for="(style, index) in dayStyles" track-by="$index" v-bind:x="index * 12" y="0" height="10" width="10" rx="2" ry="2" v-bind:class="style"/>
    </svg>
  </div>
</template>

<style scoped>
rect {
  stroke: #cccccc;
}
rect.q0 {
  fill: white;
}
rect.q1 {
  fill: Lavender;
}
rect.q2 {
  fill: Thistle;
}
rect.q3 {
  fill: Violet;
}
rect.q4 {
  fill: Magenta;
}
</style>

<script>
// import _ from 'underscore'
import moment from 'moment'

export default {
  $el () {
    return '#el'
  },

  data () {
    return {
      dayStyles: [],
      trackDays: {}
    }
  },

  props: {
    dateStart: {
      type: String,
      required: true,
      default: () => ('')
    },
    dateEnd: {
      type: String,
      required: true,
      default: () => ('')
    },
    days: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },

  methods: {
    buildTrackdays: function () {
      var date = moment(this.dateStart, 'x')

      do {
        this.trackDays[date.format('YYYYMMDD')] = 0
        date = date.add(1, 'day')
      }
      while (date.format('x') < this.dateEnd)
      // console.log('start', this.trackDays)
    }
  },

  mouted () {
    var date, keys, i
    var dayStyles = []
    var dayCount, dayStyle

    this.buildTrackdays()
    for (i = 0; i < this.days.length; i++) {
      date = moment(this.days[i].timestamp, 'x').format('YYYYMMDD')
      // console.log('considering date', date, this.days[i].range)
      if (date in this.trackDays) {
        this.trackDays[date]++
      }
    }

    // build the string representation
    keys = Object.keys(this.trackDays).sort()
    for (i = 0; i < keys.length; i++) {
      dayCount = this.trackDays[keys[i]]

      if (dayCount === 0) {
        dayStyle = 'q0'
      } else if (dayCount > 0 && dayCount <= 50) {
        dayStyle = 'q1'
      } else if (dayCount > 51 && dayCount <= 100) {
        dayStyle = 'q2'
      } else if (dayCount > 101 && dayCount <= 200) {
        dayStyle = 'q3'
      } else {
        dayStyle = 'q4'
      }

      dayStyles.push(dayStyle) // this.trackDays[keys[i]] === 1 ? 'present' : 'missing')
    }

    this.dayStyles = dayStyles
    // console.log('dayStyles', dayStyles)
    // this.daysString = _.pluck(this.days, 'range').join(', ')
  }

}
</script>



// WEBPACK FOOTER //
// EventDays.vue?7b1f8910